import { render } from "./Bonfire.vue?vue&type=template&id=0072b568&scoped=true"
import script from "./Bonfire.vue?vue&type=script&lang=js"
export * from "./Bonfire.vue?vue&type=script&lang=js"

import "./Bonfire.vue?vue&type=style&index=0&id=0072b568&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0072b568"]])

export default __exports__